import { render, staticRenderFns } from "./ViewFirmsTable.vue?vue&type=template&id=dc65033c&scoped=true"
import script from "./ViewFirmsTable.vue?vue&type=script&lang=js"
export * from "./ViewFirmsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc65033c",
  null
  
)

export default component.exports